<template>
  <div>
    <v-row class="my-3" dense>

      <v-col cols="1"
             class="ml-5 mt-7"
      >
        <v-card elevation="0">
          <v-icon color="primary"
                  x-large
                  class="mt-5 ml-2 center"
          >
            mdi-play-circle
          </v-icon>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-list-item three-line>
          <v-list-item-content>
            <v-row>
              <v-col class="mt-1 font-weight-medium pb-0">
                {{video.title}}
              </v-col>
            </v-row>

            <v-row class="mt-0">
              <v-chip small outlined class="ml-3 mt-0">
                ID:{{video._id}}
              </v-chip>
            </v-row>

          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-divider vertical />

      <v-col class="mr-5 pr-2">
        <v-card-text>
          {{video.description}}
        </v-card-text>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ResourceVideo",
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
};
</script>